// extracted by mini-css-extract-plugin
export default {"host":"FieldLabel_host__A6iVW"};